import AppConfig from '../AppConfig';

type FeatureFlagKey = keyof typeof AppConfig.featureFlags;

export function useFeatureFlag(flagKey: FeatureFlagKey): boolean {
  const flag = AppConfig.featureFlags[flagKey];
  return flag?.enabled ?? false;
}
